import { getAxiosInstance } from '../client';
/** Mutation functions for appointments domain */
export const appointmentsMutations = {
    /** POST /appointments - Create a new appointment */
    create: (dto) => getAxiosInstance()
        .post('/appointments', dto)
        .then((r) => r.data),
    /** PATCH /appointments/:id - Update appointment */
    update: (id, dto) => getAxiosInstance()
        .patch(`/appointments/${id}`, dto)
        .then((r) => r.data),
    /**
     * POST /appointments/:id/cancel - Cancel the whole appointment. Without `origin` the
     * backend takes it for a Praxisabsage; a patient's Absage may carry `receivedAt`.
     */
    cancel: (id, dto = {}) => getAxiosInstance()
        .post(`/appointments/${id}/cancel`, dto)
        .then((r) => r.data),
    /**
     * POST /appointments/:id/participants/:patientId/absage — the office records one
     * patient's Absage with when it reached the practice (TM-9737). In a group the
     * appointment stands for the others; on its only patient it is cancelled.
     */
    recordAbsage: (id, patientId, dto = {}) => getAxiosInstance()
        .post(`/appointments/${id}/participants/${patientId}/absage`, dto)
        .then((r) => r.data),
    /** POST /appointments/:id/accept-invite - Record a patient's invite acceptance (moves SCHEDULED → CONFIRMED) */
    acceptInvite: (id) => getAxiosInstance()
        .post(`/appointments/${id}/accept-invite`)
        .then((r) => r.data),
    /**
     * POST /appointments/:id/confirm — records each participant's Terminstatus
     * (Erschienen / Nicht erschienen / a cancellation saying who cancelled and, for the
     * patient's, when it was received). `deliveredAt` is derived server-side from
     * `scheduledStart + plannedDuration`.
     */
    confirm: (id, dto) => getAxiosInstance()
        .post(`/appointments/${id}/confirm`, dto)
        .then((r) => r.data),
    /** POST /appointments/batch-from-plan - Create multiple appointments linked to a TreatmentPlan */
    createBatchFromPlan: (dto) => getAxiosInstance()
        .post('/appointments/batch-from-plan', dto)
        .then((r) => r.data),
    /** POST /appointments/batch - Create multiple plain appointments without a TreatmentPlan link */
    createBatch: (dto) => getAxiosInstance()
        .post('/appointments/batch', dto)
        .then((r) => r.data),
    /**
     * POST /appointments/:id/associate-with-plan — adopt a phase-1 standalone
     * appointment into a treatment plan (TM-9168 slice 2). Link-only: the
     * appointment keeps its slot and consumes the listed units.
     */
    associateWithPlan: (id, dto) => getAxiosInstance()
        .post(`/appointments/${id}/associate-with-plan`, dto)
        .then((r) => r.data),
    /**
     * POST /appointments/:id/dissociate-from-plan — un-adopt a previously
     * adopted appointment (TM-9168 slice 5). The appointment keeps its slot;
     * the linked plan units return to PLANNED. Lossless — original free-text
     * `service` is preserved.
     */
    dissociateFromPlan: (id) => getAxiosInstance()
        .post(`/appointments/${id}/dissociate-from-plan`)
        .then((r) => r.data),
    /**
     * PUT /appointments/:id/plan-link — sets one patient's Verordnung on the
     * appointment (#1896): a plan links or swaps, none unlinks. Answers once the
     * units moved.
     */
    setPlanLink: (id, dto) => getAxiosInstance()
        .put(`/appointments/${id}/plan-link`, dto)
        .then((r) => r.data),
    /**
     * PATCH /appointments/:id/participants — adds and removes patients (#1898). Added
     * patients are invited; a removed patient's units go back to their Verordnung.
     */
    changeParticipants: (id, dto) => getAxiosInstance()
        .patch(`/appointments/${id}/participants`, dto)
        .then((r) => r.data),
    /**
     * PATCH /appointments/participants/status-by-token — magic-link acceptance
     * (public endpoint used by the email call-accept / call-decline links).
     */
    updateParticipantStatusByInviteToken: (dto) => getAxiosInstance()
        .patch('/appointments/participants/status-by-token', dto)
        .then((r) => r.data),
    /**
     * PATCH /appointments/:id/participant-status — authenticated in-app
     * accept/decline (notification banner buttons). The patient is the
     * authenticated caller (self only, enforced server-side). Appointment-driven,
     * so it works for in-person appointments too.
     */
    updateOwnParticipantStatus: (id, dto) => getAxiosInstance()
        .patch(`/appointments/${id}/participant-status`, dto)
        .then((r) => r.data),
    /**
     * POST /users/:userId/appointments/withdraw — patient self-service
     * cancellation (TM-9436 / #1334). `appointmentRef` is a real appointment id or
     * a `virtual:<seriesId>:<occurrenceKey>` ref; the withdrawal always records
     * `origin=PATIENT` server-side. Self only, enforced server-side.
     */
    withdrawFromAppointment: (userId, dto) => getAxiosInstance()
        .post(`/users/${userId}/appointments/withdraw`, dto)
        .then((r) => r.data),
};
//# sourceMappingURL=appointments.mutations.js.map